import { render, staticRenderFns } from "./IconHeaderProfile.vue?vue&type=template&id=1c8ad3e3&"
import script from "./IconHeaderProfile.vue?vue&type=script&lang=js&"
export * from "./IconHeaderProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports